import * as React from 'react'

import { Stack, Skeleton } from '@mui/material'

import { useCourseProgress } from 'components/hooks/state'
import ModuleCard from 'components/atomic/organisms/syllabus/components/module-item'

import { Track } from 'types/types'

const SyllabusLoading = () => {
    return (
        <Stack spacing="1rem">
            <Skeleton variant="rounded" width={'20%'} height="2rem" />
            <Skeleton variant="rounded" width={'100%'} height="4rem" />
            <Skeleton variant="rounded" width={'100%'} height="4rem" />
            <Skeleton variant="rounded" width={'100%'} height="4rem" />
            <Skeleton variant="rounded" width={'100%'} height="4rem" />
        </Stack>
    )
}

interface SyllabusProps {
    course: Track
}

const Syllabus = ({ course }: SyllabusProps) => {
    const { data: courseProgress, loading } = useCourseProgress({ courseId: course._id })

    if (loading) return <SyllabusLoading />

    return (
        <Stack spacing={1}>
            {course.modules.map((item, index) => (
                <ModuleCard
                    key={item._id}
                    index={index}
                    rootId={course._id}
                    rootType="course"
                    module={item}
                    moduleProgress={courseProgress?.modules.find((m) => m._id === item._id)}
                    resourceIds={item.resources}
                    resourceProgress={courseProgress?.resources}
                />
            ))}
        </Stack>
    )
}

export default Syllabus
